import React from "react";

import { IShareQueryBtn } from "../@types";
import TooltipButton from "../TooltipButton";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const ShareQueryBtn = ({ onClick, disabled, label }: IShareQueryBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.SHARE_QUERY })}
    label={label || "Share query"}
    disabled={disabled}
    type="share"
  />
);
